/* eslint-disable no-underscore-dangle */
import React from "react";
import PropTypes from "prop-types";
import Service from "./Service";
import OwlCarousel from 'react-owl-carousel2'

const ServiceList = ({
  list,
  itemClassName,
  iconStyle,
  imgStyle,
  className,
  count,
}) => {
  console.log(list);
  let listToRender = list;
  if (count) {
    listToRender = list.slice(0, count);
  }
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const pathname = window.location.pathname;

  const carouselOptions = {
    items: 2,
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    // navText: [
    //   '<img src="/img/arrow-right.svg" id="custom-prev">',
    //   '<img src="/img/arrow-right.svg" id="custom-next">'
    // ],
    // navText:["<span aria-label=\"Previous\">‹</span>","<span aria-label=\"Next\">›</span>"],
    // responsiveClass: true,
    responsive: {
      0: {
        items: 1.5,
      },
      480: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 2,
      },
      1200: {
        items: 2,
      },
    },
  }

  return (
    <div className={className}>
      <div className="row" style={{ marginLeft: 0, marginRight: 0 }}>
        {listToRender.map((item) => (
          // <div key={item._id} className="col-lg-3 col-md-6 col-sm-6 col-12">
          <>
          <div
            key={item._id}
            // className={
            //   pathname != "/services" && pathname.includes("/services")
            //     ? "col-lg-12 col-md-6 col-sm-6 col-12"
            //     : "col-lg-3 col-md-6 col-sm-6 col-12"
            // }
            className="col-lg-3 col-md-6 col-sm-6 col-12 desktop-service-list"
          >
            <Service
              iconStyle={iconStyle}
              imgStyle={imgStyle}
              id={item.slug}
              key={item._id}
              title={item.title}
              imageTag={item.imageTag}
              icon={`${BASE_URL}/${item.icon.thumbnail}`}
              shortDescription={item.shortDescription}
            />
          </div>
          </>
        ))}
      </div>
      <div className="service-wrapper-mobiles">
      <OwlCarousel
                options={carouselOptions}
                className="owl-carousel owl-theme newsevents-slider mobile-service-wrapper"
              >
                {listToRender.map(item => (
                  <div key={item._id} className="item">
                    <Service
              
             
              id={item.slug}
              key={item._id}
              title={item.title}
              imageTag={item.imageTag}
              icon={`${BASE_URL}/${item.icon.thumbnail}`}
              shortDescription={item.shortDescription}
            />
                  </div>
                ))}
              </OwlCarousel>

      </div>
    </div>
  );
};

ServiceList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.isRequired,
      title: PropTypes.isRequired,
      icon: PropTypes.isRequired,
      shortDescription: PropTypes.isRequired,
    })
  ).isRequired,
  itemClassName: PropTypes.string,
  className: PropTypes.string,
  count: PropTypes.number,
};

ServiceList.defaultProps = {
  itemClassName: "col-lg-4 col-md-6 col-sm-6 col-12",
  className: "services-list-wrapper",
  count: null,
};

export default ServiceList;
